import { memo } from "react";

import { Modal, Stack, Text } from "@mantine/core";

type PaymentRecipientInfoModalData = {
  isOpen: boolean;
  onClose: () => void;
};

const PaymentRecipientInfoModal = ({
  isOpen,
  onClose,
}: PaymentRecipientInfoModalData) => {
  return (
    <Modal
      centered
      size={"lg"}
      opened={isOpen}
      onClose={onClose}
      title="Primary sales recipient"
    >
      <Stack>
        <Text size="sm">
          By default, all primary sales will go to your connected address unless
          you add a different address here.
        </Text>
        <Text size="sm">
          For splits, we recommend{" "}
          <a target="_blank" href="https://www.0xsplits.xyz" rel="noreferrer">
            0xSplits
          </a>
        </Text>
      </Stack>
    </Modal>
  );
};

export default memo(PaymentRecipientInfoModal);
